import React, { Component } from 'react';
import cn from 'classnames';
import { withRouter } from 'react-router';
import { Dropdown, Menu, Tabs } from 'antd';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import Icon from '../../../../../../common/UI/Icon';
import Badge from '../../../../../../common/UI/Badge';
import ButtonTransparent from '../../../../../../common/UI/ButtonTransparent';

import { connect } from '../../../../../../StateProvider';

import { resolveViewType, VIEW_TYPES } from '../../../../../../../utils/viewType';

import * as catalogActions from './catalogActions';
import * as viewActions from './viewActions';
import * as sectionActions from './sectionActions';

import styles from './actions.less';

class CatalogActions extends Component {
  static propTypes = {
    catalog: PropTypes.object,
    sectionId: PropTypes.string,
    catalogId: PropTypes.string,
    history: PropTypes.object,
  };

  constructor(props) {
    super(props);

    // проброс функций из вспомогательных файлов
    [catalogActions, viewActions, sectionActions].map((actions) => {
      Object.keys(actions).forEach((key) => {
        if (typeof actions[key] === 'function') {
          this[key] = actions[key].bind(this);
        }
      });
    });
  }

  render() {
    const { type, catalogId, viewId, sectionId, title, className, t } = this.props;

    let modes = this.props.modes;
    if (!modes) {
      modes = ['catalog', 'view', 'section'];
    }

    // items & badge
    let menu = [];
    let badge;
    const inGroup = true; //! mode;
    if (modes.includes('catalog') && catalogId) {
      menu = menu.concat(this.catalogItems(inGroup));
      badge = badge || (this.catalogBadge && this.catalogBadge());
    }

    if (modes.includes('view') && viewId) {
      menu = menu.concat(this.viewItems(inGroup));
      badge = badge || (this.viewBadge && this.viewBadge());
    }

    if (modes.includes('section') && sectionId) {
      menu = menu.concat(this.sectionItems(inGroup));
      badge = badge || (this.sectionBadge && this.sectionBadge());
    }

    // if empty action list
    if (!menu.length) return null;

    if (type == 'menu') {
      return <Menu items={menu} mode="inline" theme="" inlineIndent="15" className={className} />;
    }
    return (
      <Dropdown
        menu={{ items: menu }}
        overlayClassName={styles.dropdownMenu}
        trigger={['click']}
        placement="bottomRight"
      >
        <ButtonTransparent className={cn(styles.actionsButton, className)} title={title}>
          <Badge dot={badge}>
            <Icon type="icon setting-10" />
          </Badge>
        </ButtonTransparent>
      </Dropdown>
    );
  }
}

export default withRouter(
  connect(
    withTranslation()(CatalogActions),
    {
      favoriteCatalogs: ['userSettings', 'ui', 'favoriteCatalogs'],
      sections: ['sections'],
      scenes: ['scenes'],
      viewSettings: ['viewSettings', 'catalogs'],
      viewSettingsClipboard: ['viewSettingsClipboard'],
    },
    (props, { favoriteCatalogs, sections, scenes, viewSettings, viewSettingsClipboard }) => {
      const { sceneId, catalog, match } = props;

      // catalog
      const catalogId = catalog && catalog.get('id');

      // section
      let { sectionId } = props;
      sectionId = sectionId || (catalog && catalog.get('sectionId'));
      const section = sectionId && sections.get(sectionId);

      // view
      let { viewId } = props;
      viewId = viewId || (match && match.params && match.params.viewId);

      // extra view data
      /* сделано для добавления нового вида из сцены, так как в каталог новый вид не сохраяняется, а список видов отображается по видам каталога */
      const sceneView = scenes.getIn([sceneId, 'views', viewId]);
      const views = catalog && catalog.get('views');
      const catalogView = views && views.find((v) => v.get('id') === viewId);
      const view = sceneView || catalogView;
      const settings = viewSettings && viewSettings.getIn([String(catalogId), 'views', String(viewId)]);
      const viewSettingsChanged = settings && settings.get('hasChanges');
      const hasPersonalSettings = settings && settings.get('hasPersonalSettings');

      const viewType = resolveViewType(view);
      const hasGlobalBaseline =
        String(viewId) === '0' || viewType === VIEW_TYPES.SHARED || viewType === VIEW_TYPES.GLOBAL;
      const hasPersonalOverrides = Boolean(hasPersonalSettings && hasGlobalBaseline);

      return {
        ...props,

        sectionId,
        section,

        catalogId,

        favoriteCatalogs,

        viewId,
        view,

        views,
        viewSettingsChanged,
        hasPersonalSettings,
        hasPersonalOverrides,
        viewSettings,
        viewSettingsClipboard,
      };
    },
  ),
);
